var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view',{attrs:{"date-range":_vm.dateRange,"loading":_vm.loading},on:{"loading":function($event){return _vm.$emit('loading', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }